/** The page number a `?page=` value asks for: a whole number from 1, anything else is page 1. */
export function pageFromParam(raw: string | null | undefined): number {
  if (!raw || !/^\d{1,9}$/.test(raw.trim())) return 1;
  const n = Number(raw.trim());
  return n >= 1 ? n : 1;
}

/** The value to write for a page: nothing for page 1, so the first page keeps a clean address. */
export function pageToParam(page: number): string | null {
  const n = Math.floor(Number(page));
  return Number.isFinite(n) && n > 1 ? String(n) : null;
}

/** A copy of `params` without `<prefix>` and any `<prefix>-…` parameter. */
export function withoutPageParams(params: URLSearchParams, prefix = 'page'): URLSearchParams {
  const next = new URLSearchParams(params);
  for (const key of [...next.keys()]) {
    if (key === prefix || key.startsWith(`${prefix}-`)) next.delete(key);
  }
  return next;
}
